export const customerInfoFormFields = [
  {
    type: 'text',
    name: 'fullName',
    label: 'Full Name',
    placeholder: 'Enter Full Name',
    example: 'Eg: Aman Singh (Not Aman)',
    config: {
      required: true,
    },
  },
  {
    type: 'number',
    name: 'phoneNumber',
    label: 'Mobile Number',
    placeholder: 'Enter 10 digit Mobile number',
    maxLength: 10,
    keyboardType: 'phone-pad',
    isEditable: false,
    config: {
      required: true,
    },
  },
  {
    type: 'text',
    name: 'email',
    label: 'Email ID',
    placeholder: 'Enter valid email ID',
    keyboardType: 'email-address',
    example: 'Eg: username@email.com',
    config: {
      required: true,
    },
  },
]
